import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryNavSection from './components/CategoryNavSection';
import LatestSection from './components/LatestSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/comics';

export default function Home() {
  useEffect(() => {
    document.title = '免费韩漫在线阅读-好看的韩国漫画-韩国漫画大全-奇妙漫画网';
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: typeof window !== 'undefined' ? 'http://xinzhewash.com' : '',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: '/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: typeof window !== 'undefined' ? 'http://xinzhewash.com' : '',
    description: siteInfo.description,
    email: siteInfo.email,
    foundingDate: siteInfo.foundingYear,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategoryNavSection />
        <LatestSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}